import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import './index.sass';
import { NavLink } from 'react-router-dom';

const { cnBlock, el } = bem('menu-link');

const menuLink = ({ className, to, href, name, isActive, disabled, id }) => {
    return (
      href ? <a
          href={ href }
          id={ id }
          className={ cnBlock(className, { disabled, 'is-active': isActive }) }>
            <Text
              className={ el('text') }
              dangerouslySetInnerHTML={ { __html: name } }
            >
            </Text>
        </a> :
        <NavLink
          id={ id }
          className={ cnBlock(className) }
          to={ to }
          end
        >
            <Text>{ name }</Text>
        </NavLink>
    )
};

export default menuLink;
